import { LoomIcon } from '@atlaskit/logo';

import { Journeys } from '@atlassiansox/cross-flow-support/cross-flow-api-internals';

import { Targets } from '@atlassiansox/cross-flow-support/cross-flow-base-types';

import {
	AtlasSideNavAppRecommendationMenuItem,
	type ComponentProps,
} from '@post-office/browser--growth/components/atlas-side-nav-growth-item';

import { type JSX } from 'react/jsx-runtime';

const ProductLogo = () => <LoomIcon size="xsmall" appearance="brand" />;

export const AtlasSideNavRecommendationLoom = ({ ...props }: ComponentProps): JSX.Element => {
	return (
		<AtlasSideNavAppRecommendationMenuItem
			{...props}
			appName={'Loom'}
			logo={<ProductLogo />}
			targetProduct={Targets.LOOM}
			journeyType={Journeys.GET_STARTED}
		/>
	);
};
